var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartProcessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12995",
    "data-name": "Path 12995",
    d: "M22,6A16,16,0,0,0,38,22,16,16,0,0,0,22,38,16,16,0,0,0,6,22,16,16,0,0,0,22,6Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#00d62a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartProcessIcon);
export default __webpack_public_path__ + "static/media/startProcessIcon.370a7b81e5f47220e52df003050a85bc.svg";
export { ForwardRef as ReactComponent };